import { render, staticRenderFns } from "./data_complement.vue?vue&type=template&id=b3c964ee&"
import script from "./data_complement.vue?vue&type=script&lang=js&"
export * from "./data_complement.vue?vue&type=script&lang=js&"
import style0 from "./data_complement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports